import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { environment } from '../../../../environments/environment';
import { ChangePasswordComponent } from '../../../components/dialogs/change-password/change-password.component';
import { SecurityStorage } from '../../../services/storage/security.storage';

@Component({
    selector: 'sl-my-profile',
    templateUrl: './my-profile.component.html',
    styleUrls: ['./my-profile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MyProfileComponent implements OnInit {
    username: string;
    usernameOrEMail: string;
    isAirlockEnabled: boolean;

    private readonly dialog = inject(MatDialog);
    private readonly securityStorage = inject(SecurityStorage);

    constructor() {
        this.isAirlockEnabled = environment.useAirlock;
    }

    ngOnInit(): void {
        const userInfo = this.securityStorage.getUserInfo();
        this.username = userInfo?.username ?? '';
        this.usernameOrEMail = userInfo?.email ?? this.username;
    }

    openPasswordModal(): void {
        this.dialog.open(ChangePasswordComponent, {
            minWidth: '250px'
        });
    }
}
